import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=29877f08&scoped=true&"
import script from "./ChatBubble.vue?vue&type=script&lang=js&"
export * from "./ChatBubble.vue?vue&type=script&lang=js&"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=29877f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29877f08",
  null
  
)

export default component.exports